import React from "react"
import { Link } from "gatsby"
import "bulma/css/bulma.min.css"
import "./layout.css"
import "./fonts.css"
import "flexboxgrid"
import "./overlay.css"

// Full-screen black overlay page (vita / shows) with a close (X) button that
// returns to the homepage, an ornate Dragon-Limen heading and Times body text.
const Overlay = ({ title, children }) => (
  <div className="overlay">
    <Link to="/" className="overlay-close" aria-label="close">
      <svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true">
        <line
          x1="3"
          y1="3"
          x2="21"
          y2="21"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <line
          x1="21"
          y1="3"
          x2="3"
          y2="21"
          stroke="currentColor"
          strokeWidth="1.2"
        />
      </svg>
    </Link>
    {title && <h1 className="overlay-title">{title}</h1>}
    <div className="overlay-content">{children}</div>
  </div>
)

export default Overlay
